import React from 'react'
import { PageContainerToolbar } from '@toolpad/core/PageContainer'
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import SimCardDownloadOutlinedIcon from '@mui/icons-material/SimCardDownloadOutlined';
import { useDispatch, useSelector } from 'react-redux';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import ClearIcon from '@mui/icons-material/Clear';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Select from '@mui/material/Select';
import Typography from '@mui/material/Typography';
import { setStatus,setSearchQuery,setStageModalOpen,get_stage_list } from '../../../store/stage/stageSlice';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import OutlinedInput from '@mui/material/OutlinedInput';
import { STAGE_LIMIT } from '../../../helpers/constants';
import { setAction } from '../../../store/stage/stageSlice'; 
import AddIcon from '@mui/icons-material/Add';
import Fab from '@mui/material/Fab';
import { Tooltip } from '@mui/material';

const StagePageToolbar = () => {
  const dispatch = useDispatch();

  const { 
    is_stage_modal_open,
    selected_status,
    search_query,
    active_stage,
    total_stage_count,
    page
  } = useSelector((state) => state.stage);   

  const handleStatusChange = (event) => {
    const { value } = event.target;
    const newVal = value === undefined ? "" : value;
    const qn = search_query;
    const params = {
      qs : value === "Active" ? "ac" : value === "Inactive" ? "dc" : "",
      page : page+1,
      limit : STAGE_LIMIT 
    };
    if (qn) {
      params.qn = qn; 
    }    
    dispatch(setStatus(newVal));
    dispatch(get_stage_list(params));
  };

  const handleSearchChange = () => {   
    const qn = search_query;
    const qs = selected_status === "Active" ? "ac" : selected_status === "Inactive" ? "dc" : ""; 
    const params = { qn,page:page+1,limit:STAGE_LIMIT };
    if (qs) {
      params.qs = qs; 
    }
    dispatch(get_stage_list(params))
  }; 

  const handleClearSearch = () => { 
    dispatch(setSearchQuery("")); 
    const qs = selected_status === "Active" ? "ac" : selected_status === "Inactive" ? "dc" : "";
    const params = { 
      page : page+1,
      limit : STAGE_LIMIT 
    };
    if (qs) {
      params.qs = qs; 
    }    
    dispatch(get_stage_list(params)); 
  };

  const handleStageModal = (c_action) => {
    dispatch(setStageModalOpen(!is_stage_modal_open))
    dispatch(setAction(c_action))
  };  

  return (
      <PageContainerToolbar sx={{display:'flex', justifyContent : 'space-between', marginLeft: 0, width: '80vw', flexDirection : {lg:'row', md:'column', xs:'column'} }}>
        <Tooltip title={`Active: ${active_stage} / ${total_stage_count}`}>
                <Typography variant="subtitle2" fontWeight={500}display='flex' sx={{
                    alignItems : {md:'center',xs:'flex-start'},
                  }}>
                    {`Active: ${active_stage} / ${total_stage_count}`}
                </Typography>
            </Tooltip>
            
          <Box display='flex' sx={{
            flexDirection : {lg:'row', md:'column', xs:'column'},
            alignItems : {md:'center',xs:'flex-start'},
          }}>
            
            <Box sx={{
              '& .MuiFormControl-root,.MuiButtonBase-root':{
                mx:{md:1,xs:0}
              },
              '& .MuiFormControl-root' : {
                my:{lg:0,md:0.8,xs:0.8}
              },
              '& .actionButton':{
                display : {md:'flex',xs:'none'}
              },
              width : {md:'unset',xs:'100%'},
              display : 'flex',
              flexDirection : {lg:'row', md:'column', xs:'column'},
              alignItems:'center'
            }}>
              <Typography variant='subtitle2' color='textPrimary' fontWeight='500'>Filter By:</Typography>

              <FormControl size='small' 
              sx={{
                minWidth:{md:240,xs:'100%'},
                maxWidth: {md:200,xs:'100%'},
                '& .MuiOutlinedInput-input' : {
                  fontSize : '14px',
                },
                '& .MuiOutlinedInput-root' : {
                  paddingRight : '0px'
                },
                '& .MuiButtonBase-root' : {
                  marginRight : '0px',
                  marginLeft : '0px',
                  borderTopLeftRadius:'0px',
                  borderBottomLeftRadius:'0px'
                }
              }}
              >
              <OutlinedInput 
              value={search_query} 
              onChange={(e) => {
                const query = e.target.value;
                dispatch(setSearchQuery(query));
                if (query === "") {
                  handleClearSearch();
                }
              }}             
              placeholder="Stage name" 
              onKeyUp={(event) => {
                if (event.key === "Enter") {
                  handleSearchChange(); 
                }
              }}            
              endAdornment={
                <InputAdornment position="end">
                {search_query.length > 0 && (
                  <IconButton
                    size="small"
                    onClick={handleClearSearch}
                  >
                    <ClearIcon sx={{ fontSize: '18px' }} />
                  </IconButton>
                )}
                <IconButton 
                  onClick={handleSearchChange}
                  sx={{ padding: 0, margin: '5px' }}
                >
                  <ChevronRightIcon/>
                </IconButton>
              </InputAdornment>
            }
          />
          </FormControl>          
          <FormControl sx={{minWidth:{lg:200,md:'95%',xs:'100%'},maxWidth: {lg:180,md:'90%',xs:'100%'} }}>
            <Select
              endAdornment = {
                selected_status && (
                <InputAdornment position='end'>
                <IconButton size='small' onClick={handleStatusChange} sx={{mr:-1.5}}>
                  <ClearIcon sx={{fontSize:'20px'}} />
                </IconButton>
                </InputAdornment>
                )
              }
                value={selected_status}
                size='small'
                onChange={handleStatusChange}
                displayEmpty
                sx={{
                  fontSize:'13px',
                  "& .MuiOutlinedInput-input" : {
                    padding : "10px 14px",
                    paddingRight : selected_status ? '0px!important' : '32px'
                  },
                  "& .MuiSelect-icon" : {
                    display : selected_status ? 'none' : 'block',
                  },
                }}
              >
                <MenuItem disabled value="" sx={{fontSize:'14px', height: '25px'}}>
                  <p>Select a Status</p>
                </MenuItem>
                <MenuItem value="Active" sx={{fontSize:'14px', height: '25px'}} >Active</MenuItem>
                <MenuItem value="Inactive" sx={{fontSize:'14px', height: '25px'}} >Inactive</MenuItem>
            </Select>
          </FormControl>          
          <Button
            onClick={() => handleStageModal('CREATE')}
          >
            <Box sx={{ '& > :not(style)': { m: 0 } }}>
              <Fab size="small" color="primary" aria-label="add">
                <AddIcon />
              </Fab>
            </Box>
          </Button>
          <Button className='actionButton' variant='contained' disableElevation>
            <SimCardDownloadOutlinedIcon htmlColor='white'/>
          </Button>
        </Box>
      </Box>
      </PageContainerToolbar>
  )
}

export default StagePageToolbar